module.exports = __webpack_public_path__ + "media/images/icons/pause_green-8b85c37d6da9bad3f69ac0415494fc5b.svg";